<div class="empty-state-container">
  <img src="assets/img/success-state.png" alt="" />

  <h4>{{ title | translate }}</h4>
  <p>{{ description }}</p>
</div>
